import BatteryImg from "../../assets/images/unrealized/battery.png";
import EVImg from "../../assets/images/unrealized/ev.png";
import SolarImg from "../../assets/images/unrealized/solar.png";
import NewPowerAssetImg from "../../assets/images/unrealized/newPowerAsset.png";
import VacancyImg from "../../assets/images/unrealized/vacancy.png";
import UnconnectedTenantsImg from "../../assets/images/unrealized/unconnectedTenants.png";
import CarbonIcon from "../../assets/images/buildings/Carbon.svg";
import ProfitabilityIcon from "../../assets/images/buildings/Profitability.svg";
import OccupancyIcon from "../../assets/images/buildings/Occupancy.svg";
import ConnectionIcon from "../../assets/images/buildings/Connection.svg";
import UnpaidIcon from "../../assets/images/buildings/Unpaid.svg";

import RentalRevenueIcon from "../../assets/images/building/rentalRevenue.svg";
import PowerTradingRevenueIcon from "../../assets/images/building/powerTradingRevenue.svg";
import PowerAssetsRevenuesIcon from "../../assets/images/building/powerAssetRevenue.svg";
import BuildingProfitabilityIcon from "../../assets/images/building/building-profitability.svg";

export const POWER_ASSETS_IMAGES = {
  solar: SolarImg,
  ev: EVImg,
  battery: BatteryImg,
  vacancy: VacancyImg,
  new_power_asset: NewPowerAssetImg,
  unconnected_tenant: UnconnectedTenantsImg,
};

export const ANY_FILTER_KEY = "any";

export const ITEMS_PER_PAGE = 10;

export const STATUS_MAP = {
  RENTED: "Rented",
  ECONOMIC_VACANCY: "Economic vacancy",
  PHYSICAL_VACANCY: "Physical vacancy",
  CONNECTED: "Connected",
  READY_TO_CONNECT: "Ready to connect",
  STAND_BY: "Stand-by",
  PENDING: "Pending",
  FULLY_CONNECTED: "Fully Connected",
};

export const CAROUSEL_TYPE = (unitSystem, currencySymbol) => [
  {
    key: "occupancy_rate",
    name: "By Occupancy Rate",
    icon: OccupancyIcon,
    suffix: "%",
  },
  {
    key: "emission_reduction",
    name: "By Carbon emission reduction",
    icon: CarbonIcon,
    suffix: `kC02/${unitSystem}`,
  },
  {
    key: "profitability_income",
    name: "By Total Building Profitability",
    icon: ProfitabilityIcon,
    suffix: currencySymbol,
  },
  {
    key: "connection",
    name: "By Connection to PRaaS (%)",
    icon: ConnectionIcon,
    suffix: "%",
  },
  {
    key: "unpaid",
    name: "By Unpaid Electricity Bills",
    icon: UnpaidIcon,
    suffix: "%",
  },
];

export const DEMO_CAROUSEL_TYPE = (unitSystem, currencySymbol) => [
  {
    key: "rental_revenues",
    name: "By Rental Revenues",
    icon: RentalRevenueIcon,
    suffix: currencySymbol,
  },
  {
    key: "occupancy_rate",
    name: "By Occupancy Rate",
    icon: OccupancyIcon,
    suffix: "%",
  },
  {
    key: "emission_reduction",
    name: "By Carbon reduction",
    icon: CarbonIcon,
    suffix: `kC02/${unitSystem}`,
  },
  {
    key: "noi",
    name: "By NOI",
    icon: ProfitabilityIcon,
    suffix: "%",
  },
  {
    key: "connection",
    name: "By Connection to PRaaS (%)",
    icon: ConnectionIcon,
    suffix: "%",
  },
  {
    key: "power_trading_revenues",
    name: "By Power Trading Revenues",
    icon: PowerTradingRevenueIcon,
    suffix: currencySymbol,
  },
  {
    key: "power_assets_revenues",
    name: "By Power Assets Revenues",
    icon: PowerAssetsRevenuesIcon,
    suffix: currencySymbol,
  },
  {
    key: "building_profitability",
    name: "By Building Profitability",
    icon: BuildingProfitabilityIcon,
    suffix: currencySymbol,
  },
];
